import React, {useState} from 'react';
import close from "../../../../images/close.svg";
import {useTranslation} from "react-i18next";
import {Field} from "formik";
import {NavLink} from "react-router-dom";
import {userApi} from "../../../../redux/user/user-api";
import {useHistory} from "react-router";

const RecoveryEmail = ({isDark}) => {
  const {t} = useTranslation()
  const [email, setEmail] = useState('')
  const history = useHistory();
  return (
    <div style={{width: 541}} className={`modal ${isDark && 'modal__dark'}`}>
      <button onClick={history.goBack} className="modal__close">
        <img src={close} alt=""/>
      </button>
      {/*<h5 className="modal__title mr-30">Добавьте e-mail</h5>*/}
      {/*<p className="modal__text">Чтобы пользоваться функционалом Логбука, пожалуйста, добавтьте свой e-mail </p>*/}
      <h5 className="modal__title mr-30">{t('passwordRecovery')}</h5>
      <div className="modal__inputItem mt-16">
        <p className="modal__label mb-12">{t('enterEmail')}: </p>
        <div className="modal__inputWrapper w-100">
          <input autoComplete={'off'} placeholder={''} id={'email'} value={email} onChange={e => setEmail(e.target.value)}
                 type="text" className="modal__input w-100" />
        </div>
      </div>
      <div className="modal__buttons mt-12">
        <button onClick={async () => {
          await userApi.recoveryPassword(email)
          history.goBack()
        }} className="submit-button">
          {t('send')}
        </button>
        <button onClick={history.goBack} className="commonBtn">
          <span className="commonBtn__label">{t('cancel')}</span>
        </button>
      </div>
    </div>
  );
};

export default RecoveryEmail;